import { useEffect, useState } from 'react'
import { getDisplayServices } from '../Contentful'

export default function useDisplayServices(page) {
  const promise = getDisplayServices(page)
  // console.log("test 1");
  const [displayServices, setDisplayServices] = useState(null)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    promise.then(result => {
      setDisplayServices(result)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [displayServices, isLoading]
}
